import { render } from "./activityOrder.vue?vue&type=template&id=71b6db04&scoped=true"
import script from "./activityOrder.vue?vue&type=script&lang=js"
export * from "./activityOrder.vue?vue&type=script&lang=js"

import "./activityOrder.vue?vue&type=style&index=0&id=71b6db04&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b6db04"]])

export default __exports__